export function buildPlannerStoreRecovery(getters, defaults) {
  const savedSelectedOperators = getters.getPlannerSelectedOperators
  const updates = {
    originDirection: getters.getPlannerOrigin,
    destinationDirection: getters.getPlannerDestination,
    timeMode: getters.getPlannerTimeMode || 'now',
    timeModeHour: getters.getPlannerTimeModeHour || defaults.timeModeHour,
    timeModeDate: getters.getPlannerTimeModeDate || defaults.timeModeDate,
    originCoordinates: getters.getPlannerOriginCoordinates,
    destinationCoordinates: getters.getPlannerDestinationCoordinates,
    selectedTransports: getters.getPlannerSelectedTransports || defaults.selectedTransports,
    selectedTime: getters.getPlannerSelectedTime || defaults.selectedTime
  }

  if (getters.plannerResponse) {
    updates.googleRoutesResponse = getters.getPlannerResponse
    updates.googleStatusResponse = 'OK'
  }

  if (savedSelectedOperators && Object.keys(savedSelectedOperators).length > 0) {
    updates.selectedOperators = { ...savedSelectedOperators }
  }

  return {
    updates,
    shouldScroll: Boolean(getters.plannerResponse)
  }
}
